module.exports = __webpack_public_path__ + "d62893eab199b84f411417ff409fab6d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BV.svg
// module id = 4BYk
// module chunks = 0